// project imports
import DateObject from 'react-date-object';
import persian from 'react-date-object/calendars/persian';
import persian_fa from 'react-date-object/locales/persian_fa';
import persian_en from 'react-date-object/locales/persian_en';
import gregorian from 'react-date-object/calendars/gregorian';
import gregorian_en from 'react-date-object/locales/gregorian_en';

// ===============================|| Date ||=============================== //

export const ConvertDate = (date, format = 'YYYY/MM/DD', options = {}) => {
    return new DateObject({
        date: date,
        calendar: persian,
        locale: persian_fa,
        ...options
    }).format(format);
};

export default ConvertDate;

export const GregorianDate = (date, format = 'YYYY/MM/DD') => {
    return new DateObject({
        date: date,
        calendar: persian,
        locale: persian_en
    })
        .setCalendar(gregorian)
        .format(format);
};

export const PersianDate = (date, format = 'YYYY/MM/DD') => {
    return new DateObject({
        date: date,
        calendar: gregorian,
        locale: gregorian_en
    })
        .setCalendar(persian)
        .format(format);
};

// Next pay date
export const NextPayDate = (periodType, periodDay, remainDays) => {
    const newDate = NextPayDateGreg(remainDays);
    let format = periodType.toLowerCase() != 'month' ? 'YYYY/MM/DD' : 'YYYY/MM/' + ('0' + periodDay).slice(-2);
    let nextPayDate = '';
    if (1 /* shamsi */) {
        if (periodType.toLowerCase() == 'month') format = 'YYYY/MM/' + ('0' + GregDayToPersianDay(newDate, periodDay)).slice(-2);
        const shamsi = ConvertDate(newDate, format);
        nextPayDate = String(shamsi);
    } else {
        nextPayDate = String(newDate.format(format));
    }

    return nextPayDate;
};

// Next pay date
export const NextPayDateGreg = (remainDays) => {
    const date = new Date();
    return new Date(date.setDate(date.getDate() - parseInt(remainDays)));
};

export const PersianDayToGregDay = (date, day) => {
    try {
        const persianDate = PersianDate(date, 'YYYY/MM/DD').substring(0, 8) + day;
        return parseInt(GregorianDate(persianDate, 'YYYY/MM/DD').substring(8, 10));
    } catch (error) {
        return 0;
    }
};

export const GregDayToPersianDay = (date, day) => {
    try {
        const gregDate = new DateObject(date).format('YYYY/MM/DD').substring(0, 8) + day;
        return parseInt(PersianDate(gregDate, 'YYYY/MM/DD').substring(8, 10));
    } catch (error) {
        return 0;
    }
};

export const TimeCounter = (startDate, endDate, showDay = true, showHour = true, showMin = true, showSec = false) => {
    const startStamp = new Date(startDate).getTime(); // YYYY (M-1) D H m s ms (start time and date from DB)

    const newStamp = new Date(endDate).getTime();

    let diff = Math.round((newStamp - startStamp) / 1000);

    const d = Math.floor(diff / (24 * 60 * 60)); /* though I hope she won't be working for consecutive days :) */
    diff = diff - d * 24 * 60 * 60;
    const h = Math.floor(diff / (60 * 60));
    diff = diff - h * 60 * 60;
    const m = Math.floor(diff / 60);
    diff = diff - m * 60;
    const s = diff;

    let ret = '';
    if (showDay) ret += `${d} روز`;
    if (showHour) ret += ` و ${h} ساعت`;
    if (showMin) ret += ` و ${m} دقیقه`;
    if (showSec) ret += ` و ${s} ثانیه`;
    return ret;
};

export const DateString = (strDate) => {
    return typeof strDate.toDate === 'function' ? strDate.toDate().toISOString() : new Date(strDate).toISOString();
};

export const MergeDateTime = (strDate, strTime) => {
    const sDate = ToEnDigit(strDate instanceof Date ? strDate.toISOString() : DateString(strDate));
    const sTime = ToEnDigit(strTime instanceof Date ? strTime.toISOString() : DateString(strTime));
    if (sTime.indexOf('T') < 0) {
        return sDate.split('T')?.[0] + 'T' + (sTime || '00:00').toString();
    } else {
        return sDate.split('T')?.[0] + 'T' + sTime.split('T')?.[1];
    }
};

export const ToEnDigit = (value) => {
    return value?.toString().replace(/[٠-٩۰-۹]/g, (n) => 15 & n.charCodeAt(0));
};

// A date (DateObject of the picker / Date / ISO string) -> "YYYY-MM-DD" of the LOCAL day that the user picked.
// (DateString() gives the UTC day: a picked day 00:00 in Tehran is the day before in UTC.)
export const LocalDateString = (value) => {
    if (!value) return '';
    const d = typeof value.toDate === 'function' ? value.toDate() : new Date(value);
    if (isNaN(d.getTime())) return '';
    const pad = (n) => String(n).padStart(2, '0');
    return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
};

// A plain Gregorian day "YYYY-MM-DD" (a DATE column, like payment_settings.lock_date) -> Jalali.
// ConvertDate() with such a string reads it as a Jalali date (the year 2026 of the Jalali calendar), so the day is
// moved to noon of the local day first.
export const ConvertDay = (ymd, format = 'YYYY/MM/DD') => {
    if (!ymd) return '';
    const [y, m, d] = String(ymd).slice(0, 10).split('-').map(Number);
    return ConvertDate(new Date(y, m - 1, d, 12, 0, 0), format);
};

export { DateObject };
